export interface TourSourceCard {
  description: string
  label: string
  title: string
}
